module.exports = require('./lib/dom-scroll-into-view');



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/dom-scroll-into-view/index.js
// module id = 593
// module chunks = 2